import React, { useCallback, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaPlusCircle } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { BrComerceApiService } from "../../../../../services/BrComerceApiService";

import useGetWindowWidth from "../../../../../utils/useGetWindowWidth";

import InputSelectAsync from "../../../../../components/InputSelectAsync";
import { Loading } from "../../../../../components/Loading";
import AutocompleteInput from "../../../components/AutoCompletInput";
import Container from "../../../components/Container";
import { PackageCard } from "../../../components/PackageCard";

import Swal from "sweetalert2";

import { ScanModal } from "../../../components/ScanModal";
import styles from "./styles.module.scss";


const AddRoutes = () => {

    const history = useHistory();

    const api = new BrComerceApiService();
    const widthWindows = useGetWindowWidth();

    const [loading, setLoading] = useState(false);
    const [searchDriver, setSearchDriver] = useState("");

    const [startData, setStartData] = useState({
        value: "",
        error: "",
        latLong: { lat: "", lng: "" },
        isOK: "vazio",
    });

    const [endData, setEndData] = useState({
        value: "",
        error: "",
        latLong: { lat: "", lng: "" },
        isOK: "vazio",
    });

    const handleChange = (event, setState) => {
        const { name, value } = event.target;
        setState((prevData) => ({
            ...prevData,
            [name]: value,
            error: value?.length < 3 || !value ? 'Campo obrigatório' : "",
            isOK: value?.length < 3 || !value ? 'notOk' : "vazio"
        }));
    };

    const [packages, setPackages] = useState([]);
    const [addPackageModal, setAddPackageModal] = useState(false);
    const [packagesExpand, setPackagesExpand] = useState([]);

    const createNewRoute = async () => {
        setLoading(true);

        const originDestination = {
            origin: {
                latitude: startData.latLong.lat,
                longitude: startData.latLong.lng,
                address: startData.value
            },
            destination: {
                latitude: endData.latLong.lat,
                longitude: endData.latLong.lng,
                address: endData.value
            }
        }

        const shippings = packages.map((p) => {
            return {
                id_shipping: p.id
            }
        })

        const body = {
            idDriver: searchDriver?.value,
            type: "delivery",
            originDestination,
            shippings
        }
        console.log("🚀 ~ createNewRoute ~ body:", body)

        await api
            .makeHttpRequest({
                method: "POST",
                url: `/route-shipping-admin`,
                data: body
            })
            .then(() => {
                Swal.fire({
                    icon: "success",
                    title: "Sucesso",
                    text: "Rota criado com sucesso!",
                    showCancelButton: false,
                    confirmButtonText: "Ok"
                }).then(() => {
                    history.push("/listagem-rotas");
                });
            })
            .catch(err => {
                console.log("🚀 ~ 207 createNewRoute ~ err:", err)
                const errorMsg = err?.response?.data?.message || "Não foi possível criar a rota.";
                Swal.fire({
                    icon: "error",
                    title: "Erro",
                    text: errorMsg
                });
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const handlePackageExpand = useCallback(
        pack => {
            const find = packagesExpand.find(p => p.id === pack.id);
            if (find) {
                const newPacks = packagesExpand.filter(p => p.id !== pack.id);
                setPackagesExpand([...newPacks]);
            } else {
                packagesExpand.push(pack);
                setPackagesExpand([...packagesExpand]);
            }
        },
        [packagesExpand]
    );

    const handleRemoveShipping = useCallback(
        shippingId => {
            setPackages(prevPackages =>
                prevPackages.filter(pack => pack.id !== shippingId)
            );
        },
        [packages]
    );

    return (
        <>
            <Loading loading={loading} />
            <ScanModal
                setLoading={setLoading}
                packages={packages}
                setPackages={setPackages}
                addPackageModal={addPackageModal}
                setAddPackageModal={setAddPackageModal}
            />

            <Container title="Criar nova rota">
                <p className={styles.title}>Preencha os campos abaixo com as infomações da rota que deseja criar:</p>
                <Row className={styles.row}>
                    <Col className={styles.inputDriver}>
                        <InputSelectAsync
                            search={searchDriver}
                            setSearch={setSearchDriver}
                            listUserOrDriver={"driver"}
                            applyingBorders={true}
                        />
                        {searchDriver == null && <p className={styles.error}>{"Campo Obrigatório"}</p>}
                    </Col>
                </Row>
                <Row className={styles.row}>
                    <Col>
                        <p className={styles.textAddress}>Dados de enredereço</p>
                    </Col>
                </Row>
                <Row className={`${styles.row} ${styles.inputAddress}`}>
                    <Col>
                        <div className={styles.input} role={startData.isOK}>
                            <AutocompleteInput
                                placeholder={"Digite o endereço de início"}
                                name={"value"}
                                value={startData.value}
                                handleChange={handleChange}
                                setState={setStartData}
                            />
                        </div>
                        {startData.error && <p className={styles.error}>{startData.error}</p>}
                    </Col>
                    <Col>
                        <div className={styles.input} role={endData.isOK} >
                            <AutocompleteInput
                                placeholder={"Digite o endereço final"}
                                name={"value"}
                                value={endData.value}
                                handleChange={handleChange}
                                setState={setEndData}
                            />
                        </div>
                        {endData.error && <p className={styles.error}>{endData.error}</p>}
                    </Col>
                </Row>
                <Row className={styles.row}>
                    <Col>
                        <p className={styles.textPackage}>{`Pacotes ${!!packages?.length ? `(${String(packages?.length).padStart(2, '0')})` : ""}`}</p>
                    </Col>
                </Row>
                <div className={styles.actionsButton}>
                    <button
                        type="button"
                        onClick={() => setAddPackageModal(true)}
                        className={`${styles.package}`}
                        disabled={
                            !searchDriver ||
                            startData.isOK !== "ok" ||
                            endData.isOK !== "ok"
                        }
                    >
                        <FaPlusCircle size={16} color="#FFFFFF" />
                        <span>Adicionar pacotes</span>
                    </button>
                </div>
                {!!packages?.length &&
                    <div className={styles.packageContainer}>
                        <div className={styles.packagesWrapper}>
                            {packages?.map(pack => (
                                <PackageCard
                                    widthWindows={widthWindows}
                                    key={pack.id}
                                    shipping={pack}
                                    isExpand={packagesExpand.find(
                                        packExpand => pack.id === packExpand.id
                                    )}
                                    onExpand={() => handlePackageExpand(pack)}
                                    onDelete={() => handleRemoveShipping(pack.id)}
                                />
                            ))}
                        </div>
                    </div>
                }

                <div className={styles.buttonsContainer}>
                    <button
                        type="button"
                        onClick={() => createNewRoute()}
                        className={`${styles.create}`}
                        disabled={
                            !searchDriver ||
                            startData.isOK !== "ok" ||
                            endData.isOK !== "ok" ||
                            !packages?.length
                        }
                    >
                        <span>Salvar</span>
                    </button>
                </div>
            </Container>
        </>
    );
};

export { AddRoutes };

